import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaUpload } from "ecCom";

@observer
export default class UploadItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    if (args[0]) {
      args[0] = args[0].join(",");
    }
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaUpload
        ecId={`${this.props.ecId}_WeaUpload@1fky4u`}
        {...bindObj.bind()}
        onChange={this.onChange}
        datas={toJS(bindObj.valueSpan || [])}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/UploadItem.js